// extracted by mini-css-extract-plugin
export default {"pagination":"pagination_pagination__djZ22","square":"pagination_square__MWF6r","disabled":"pagination_disabled__hhV1+","active":"pagination_active__0Yu20"};